import { render } from "./ProfileSettingsPage.vue?vue&type=template&id=38b4326c&ts=true"
import script from "./ProfileSettingsPage.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__